import Logo from "./logo";

// Rule: every skin shows the original Slowed wordmark, as <Logo> draws it.
// A skin never restyles or animates the mark: no recoloring, offset plates,
// shadows, swipes, filters, drips or fly-aways on the logo.
export default function SkinLogo({ isPro, trialMode, announcement }) {
  const mark = <Logo isPro={isPro} trialMode={trialMode} />;

  if (!announcement) return mark;

  // Brief mood name in the header after apply. The mark stays mounted
  // underneath and the two cross-fade on one timeline: swapping the elements
  // outright made the name appear from nowhere and the mark snap back at the
  // end.
  return (
    <div className="skin-logo__swap" key={announcement}>
      <div className="skin-logo__swap-mark">{mark}</div>
      <div className="skin-logo__swap-name">
        <span>{announcement}</span>
      </div>
    </div>
  );
}
